<div class="state-inactive-popup">
    <div class="popup-header">
        <span class="material-icons-outlined header-icon">verified</span>
        <h2>Welcome to Senem RFP!</h2>
        <p>Your account has been created successfully</p>
    </div>
    <mat-dialog-content>
        <div class="popup-content">
            <div class="message-card">
                <span class="material-icons-outlined card-icon">schedule</span>
                <h3>Coming soon to your state</h3>
                <p>Our services are not yet available in your area. Your application has been saved and pre-filled with your registration details.</p>
                <p class="highlight">We'll send you an email notification when we launch in your state.</p>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-flat-button color="primary" class="close-btn" (click)="onClose()">Understood</button>
    </mat-dialog-actions>
</div>
